import { makeApi } from "@zodios/core";
import { z } from "zod";

export const nodeTemplateCategorySchema = z.object({
  name: z.string(),
  title: z.string(),
});

export type NodeTemplateCategory = z.infer<typeof nodeTemplateCategorySchema>;

export const nodeTemplateCategoriesApi = makeApi([
  {
    method: "get",
    path: "/node-template-categories",
    alias: "getNodeTemplateCategories",
    response: z.array(nodeTemplateCategorySchema),
  },
]);
